export default {
  translation: {
    common: {
      save: 'I-save',
      cancel: 'Kanselahin',
      delete: 'Burahin',
      edit: 'I-edit',
      add: 'Idagdag',
      search: 'Maghanap',
      loading: 'Naglo-load...',
      success: 'Tagumpay',
      error: 'Error',
      confirm: 'Kumpirmahin',
      yes: 'Oo',
      no: 'Hindi',
      back: 'Bumalik',
      next: 'Susunod',
      submit: 'Isumite',
      close: 'Isara',
      required: 'Kailangan',
      optional: 'Opsyonal',
    },
    auth: {
      login: 'Mag-login',
      logout: 'Mag-logout',
      register: 'Mag-register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Kumpirmahin ang Password',
      forgotPassword: 'Nakalimutan ang Password?',
      resetPassword: 'I-reset ang Password',
      loginSuccess: 'Matagumpay na nag-login',
      logoutSuccess: 'Matagumpay na nag-logout',
      invalidCredentials: 'Maling email o password',
      emailSent: 'Naipadala na ang email para sa pag-reset ng password',
    },
    household: {
      title: 'Sambahayan',
      createHousehold: 'Gumawa ng Sambahayan',
      householdName: 'Pangalan ng Sambahayan',
      householdAddress: 'Address',
      members: 'Miyembro',
      addMember: 'Magdagdag ng Miyembro',
      removeMember: 'Alisin ang Miyembro',
      switchHousehold: 'Magpalit ng Sambahayan',
      currentHousehold: 'Kasalukuyang Sambahayan',
      noHousehold: 'Walang sambahayan',
    },
    task: {
      title: 'Gawain',
      createTask: 'Gumawa ng Gawain',
      taskTitle: 'Pamagat',
      description: 'Deskripsyon',
      dueDate: 'Takdang Petsa',
      priority: 'Priyoridad',
      status: 'Status',
      category: 'Kategorya',
      assignTo: 'Italaga kay',
      startTask: 'Simulan',
      finishTask: 'Tapusin',
      completeTask: 'Kumpletuhin',
      cancelTask: 'Kanselahin',
      taskStarted: 'Nagsimula ang gawain',
      taskFinished: 'Natapos ang gawain',
      taskCompleted: 'Nakumpleto ang gawain',
      taskCancelled: 'Nakansela ang gawain',
      highPriority: 'Mataas',
      mediumPriority: 'Katamtaman',
      lowPriority: 'Mababa',
      pending: 'Nakabinbin',
      inProgress: 'Kasalukuyang Ginagawa',
      completed: 'Nakumpleto',
      cancelled: 'Nakansela',
    },
    expense: {
      title: 'Gastos',
      createExpense: 'Magdagdag ng Gastos',
      amount: 'Halaga',
      category: 'Kategorya',
      date: 'Petsa',
      description: 'Deskripsyon',
      receipt: 'Resibo',
      verify: 'Beripikahin',
      verified: 'Naberipika',
      pending: 'Nakabinbin',
      rejected: 'Tinanggihan',
    },
    quotation: {
      title: 'Kotasyon',
      createQuotation: 'Gumawa ng Kotasyon',
      vendor: 'Tindero',
      totalAmount: 'Kabuuang Halaga',
      validUntil: 'Válido Hanggang',
      approve: 'Aprubahan',
      reject: 'Tanggihan',
      approved: 'Naaprubahan',
      rejected: 'Tinanggihan',
      pending: 'Nakabinbin',
    },
    mealPlan: {
      title: 'Plano ng Pagkain',
      createMealPlan: 'Gumawa ng Plano ng Pagkain',
      date: 'Petsa',
      mealType: 'Uri ng Pagkain',
      breakfast: 'Almusal',
      lunch: 'Tanghalian',
      dinner: 'Hapunan',
      snack: 'Meryenda',
      approve: 'Aprubahan',
      reject: 'Tanggihan',
      aiRecommend: 'Rekomendasyon ng AI',
    },
    notification: {
      title: 'Abiso',
      markAsRead: 'Markahan bilang Nabasa',
      markAllRead: 'Markahan Lahat bilang Nabasa',
      noNotifications: 'Walang abiso',
      taskReminder: 'Paalala ng Gawain',
      expenseApproved: 'Naaprubahan ang Gastos',
      quotationApproved: 'Naaprubahan ang Kotasyon',
    },
    settings: {
      title: 'Mga Setting',
      language: 'Wika',
      theme: 'Tema',
      notifications: 'Mga Abiso',
      account: 'Account',
      privacy: 'Pribasiya',
      about: 'Tungkol sa',
      version: 'Bersyon',
      logout: 'Mag-logout',
    },
    role: {
      employer: 'Empleyador',
      maid: 'Katulong',
      familyMember: 'Miyembro ng Pamilya',
      admin: 'Admin',
    },
    backup: {
      title: 'Backup at I-restore',
      createBackup: 'Gumawa ng Backup',
      restoreBackup: 'I-restore ang Backup',
      lastBackup: 'Huling Backup',
      backupSuccess: 'Matagumpay na nag-backup',
      restoreSuccess: 'Matagumpay na na-restore',
    },
    export: {
      title: 'I-export',
      exportCSV: 'I-export bilang CSV',
      exportPDF: 'I-export bilang PDF',
      exportJSON: 'I-export bilang JSON',
      exportSuccess: 'Matagumpay na na-export',
    },
  },
}
